var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"disabled":!_vm.react_id,"title":"Send mail","icon":_vm.$icons.send_bulk},on:{"action":_vm.send}})}
var staticRenderFns = []

export { render, staticRenderFns }